import gsap from "gsap";
import Draggable from "gsap/Draggable";
import InertiaPlugin from "gsap/InertiaPlugin";
gsap.registerPlugin(Draggable);
gsap.registerPlugin(InertiaPlugin);

class homeColumnTablet {
  constructor(target){
    if(!target.inited) {
      target.inited = true;

      this.run = true;

      var self = target;
      this.self = target;
      var parent = this;

      var container = $(self);
      var wrapper = $(self).find('.home--cols--col--inner');
      this.children = $(self).find('.home--col--block');

      $(window).scrollTop(0);
      $('.home--cols--col--text').css({
        'top' : window.innerHeight*.5,
      }).hide();

      var boxHeight = (window.innerWidth*1.77) / 2;
      var imgHeight = boxHeight;
      var wrapHeight = this.children.length * boxHeight;
      var viewHeight = wrapper.offsetHeight;

      gsap.set(wrapper, {height: '100vh'});

      for (var i = 0; i < this.children.length; i++) {
        let box = this.children[i];
        gsap.set(box, {y: (i+1) * boxHeight, top: -boxHeight });
      }

      setTimeout(function(){
        $('.home--cols--col--text').css('top', window.innerHeight*.5).fadeIn(200);
      }, 1400);

      var wrapProgress = gsap.utils.wrap(0, 1);
      var snapBox = gsap.utils.snap(boxHeight);
      var clickAnimation = gsap.set({}, {});
      var proxy = document.createElement("div");
      var props = gsap.getProperty(proxy);

      this.offset=0;

      this.animation = gsap.to(this.children, {
        duration: 1,
        y: "+=" + wrapHeight,
        ease: 'power0',
        paused: true,
        // start: 0,
        repeat: -1,
        modifiers: {
          y: function(y, target) {
            y = parseFloat(y) % wrapHeight;
            return y + "px";
          }
        }
      }).progress(1 / this.children.length);

      this.drag = Draggable.create(proxy, {
        // type: "x",
        trigger: container,
        throwProps: true,
        onDrag: this.updateProgress,
        onThrowUpdate: this.updateProgress,
        // start: 0,
        // snap: {
          // y: snapBox
        // }
      });

      this.updateProgress = () => {
        this.animation.progress(wrapProgress((props("y")+this.offset) / wrapHeight));
        // console.log(animation, drag);
      }

      this.updateProgress();

      gsap.ticker.add(() => {

        if(parent.run) {

          this.offset -= 0.03 * window.homeSpeed;
          this.animation.progress(wrapProgress((props("y")+this.offset) / wrapHeight));
          // updateProgress();
          // animation.progress(wrapProgress(props("y") / wrapHeight));

          // animation.modifiers.y += 1;
          parent.checkFloaters();
          parent.checkMobile();
        }
        // this.trigger.update();
      });
      gsap.ticker.fps(60);

      /*
      function animateCarousel(direction) {

        clickAnimation.kill();

        clickAnimation = gsap.to(proxy, {
          duration: 0.3,
          y: snapBox(props("y") + direction * boxHeight),
          onUpdate: updateProgress
        });
      }
      */

      this.initFloaters();

    }
  }

  initFloaters(){
    var self = this.self;
    // console.log(self);
    self.blocks = $(self).find('.home--col--block');
    $(self.blocks).each(function(){
      this.link = $(this).find('.home--biglink');
      if($(this).find('.floaters--item').length>0){
        this.floaters = $(this).find('.floaters--item');
        for(var i=0;i<this.floaters.length;i++){
          if(!this.floaters[i].speed){
            this.floaters[i].speed = Math.random() * 5 + 1;
          }
        }
      }
    });
  }

  checkMobile(){
    var self = this.self;
    for(var i=0; i<self.blocks.length;i++){
      let block = self.blocks[i];
      var inFocus = block.getBoundingClientRect().top < window.innerHeight*.5 && block.getBoundingClientRect().bottom > window.innerHeight*.5;
      if(inFocus && this.focusedBlock !== block){
        this.focusedBlock = block;
        // console.log('vittu vaihdu', block.link);
        // $(block.link).trigger('mouseenter');
        var t = $(block).find('.projectlink').html();
        $(block).parents('.home--cols--col')
        .children('.home--cols--col--text')
        .html(t);
      }
    }
  }

  checkFloaters(){
    var self = this.self;
    for(var i=0; i<self.blocks.length;i++){
      let block = self.blocks[i];
      var inview = block.getBoundingClientRect().top < window.innerHeight*1 && block.getBoundingClientRect().bottom > 0;
      if(block.floaters){
        if(inview){
          // console.log('inview');
          block.floatersActive = true;
          $(block.floaters).each(function(){
            let id = $(this).attr('data-id');
            var rect = this.getBoundingClientRect();
            var mid = rect.top - rect.height/2;
            var prc = mid / window.innerHeight;
            var transformValue = ((window.innerHeight * .15) * prc) * this.speed;
            // console.log(mid,transformValue);

            $('.home--absolute--floaters [data-id="'+id+'"]').css({
              'top' : rect.top,
              'left' : rect.left,
              'height' : rect.height,
              'width' : rect.width,
              'opacity' : 1,
              'transform' : 'translateY('+transformValue+'px)',
            }).removeClass('notrans');
            // clearTimeout(this.time);
          });
          // console.log('viewing a block with floaters');
        } else if(!inview) {
          if(block.floatersActive){
            block.floatersActive = false;
            $(block.floaters).each(function(){
              let id = $(this).attr('data-id');
              $('.home--absolute--floaters [data-id="'+id+'"]').css('opacity', 0);
              $('.home--absolute--floaters [data-id="'+id+'"]').addClass('notrans');
            });
          }
        }
        // console.log('inview: block #',i);
      }
    }
  }

} export default homeColumnTablet;
